import z from "zod";

import { coerceObject } from "./utils";

const webPushSubscriptionSchema = z.object({
  id: z.coerce.string(),
  endpoint: z.string().url(),
  alerts: coerceObject({
    follow: z.boolean().optional(),
    follow_request: z.boolean().optional(),
    favourite: z.boolean().optional(),
    reblog: z.boolean().optional(),
    mention: z.boolean().optional(),
    poll: z.boolean().optional(),
    status: z.boolean().optional(),
    user_approved: z.boolean().optional(),
    verify_sms_prompt: z.boolean().optional(),
    chat: z.boolean().optional(),
    group_favourite: z.boolean().optional(),
    group_reblog: z.boolean().optional(),
    group_mention: z.boolean().optional(),
    group_approval: z.boolean().optional(),
    group_delete: z.boolean().optional(),
    group_role: z.boolean().optional(),
    group_request: z.boolean().optional(),
    group_promoted: z.boolean().optional(),
    group_demoted: z.boolean().optional(),
  }),
  server_key: z.string(),
});

type WebPushSubscription = z.infer<typeof webPushSubscriptionSchema>;

export { webPushSubscriptionSchema, type WebPushSubscription };
